import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Topic } from '@app/models';

@Injectable({ providedIn: 'root' })
export class TopicService {
  constructor(private httpClient: HttpClient) {
  }

  getTopics() {
    return this.httpClient
      .get<any>(`${environment.apiEndPoint}topics/read`)
      .pipe(
        map(res => res ? res.document.records as Topic[] : []),
        catchError(this.handleError)
      );
  }

  private handleError(error: any): Promise<any> {
    let retour = error?.error?.message || error?.message || error;
    if(error?.error?.data) retour += '<br />'+error?.error?.data;
    return Promise.reject(retour);
  }
}